/* eslint-disable react-hooks/exhaustive-deps */
import { each } from "lodash";
import React, { useEffect, useState } from "react";
import Form from "../Form";
import Modal, { ModalHeader, ModalTab } from "../Modal";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { custodianPreview } from "../../utils/custodian";
import { isArray, remove } from "lodash";
import { MANAGEMENT_TYPE, TAXPAYER_EXPIRED_TYPE } from "../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE";
import CustodianGroups from "./CustodianGroups";
import { addManagement, editManagement } from "../../apis/tax-portal";
import { isEmpty } from "../../utils/lodashExtend";
import { isComNum, restoreComNum } from "../../utils/validator/comNum";
import { toast } from "../../utils/toast";
import { get } from "lodash";
import { getIndustryCodes } from "../../apis/code";
import Button from "../Button";
import { scrapingTaxpayerDetailFromHometax } from "../../apis/tax-accountant-finance/auth";
import { viewLoading } from "../../utils/loading";
import { useHistory } from "react-router-dom";
import { dateToFormat, dateToViewFormat } from "../../utils/date";
import { isTaxAccountantAccountCheck } from "../../utils/taxPortal/tax-accountant";
import TaxpayerSiteInfo from "./TaxpayerSiteInfo";
import TaxpayerScheduleModal from "./TaxpayerScheduleModal";
import TaxpayerPersonInCharge from "./TaxpayerPersonInCharge";
import { isNumber } from "../../utils/number";
import TaxpayerBillings from "./TaxpayerBillings";
import ManagerForm from "./ManagerForm";
import { getTaxpayerList } from "../../store/actions";
import CounselingModal from "./CounselingModal";


const Custodian = (props) => {
  const dispatch = useDispatch();
  const { submit } = props;
  const { previewCustodian, _careCompanies, company, managerRole } = useSelector(
    (store) => ({
      previewCustodian: store.Custodian.previewCustodian,
      _careCompanies: store.Data.careCompanies,
      company: store.Profile.company,
      managerRole: store.Profile.managerRole
    }), shallowEqual
  );
  const history = useHistory();
  const [mode] = useState('modify');
  const [activeTab, setActiveTab] = useState("management");
  const [fields, setFields] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [careCompanies, setCareCompanies] = useState([]);

  const [industryCodes, setIndustryCodes] = useState([]);

  const defaultForm = {
    companyName: "", // 수임처명
    ceoName: "",  // 대표자 명
    comNum: "", // 사업자 등록 번호
    rgeNum: "", // 법인 등록 번호
    isWecake: !isEmpty(previewCustodian?.companyToTaxpayer?.company) ? "1" : "0",
    ...(previewCustodian || {}),
  };

  const tabList = [
    { label: "수임회사 정보", value: "management", action: setActiveTab },
    { label: "기타정보", value: "etc", action: setActiveTab },
    { label: "홈택스 등록정보", value: "hometax", action: setActiveTab, isHide: () => !previewCustodian?.isScraping },
    {
      label: "매니저정보", value: "manager", action: setActiveTab,
      isHide: () => !managerRole?.permissions?.find(f => f.code === "COMPANY_ACCOUNT")
        && !previewCustodian?.taxpayerManagerEmployees.find(f => f.idx === company?.employeeIdx)
    },
    { label: "추가정보", value: "siteInfo", action: setActiveTab },
    {
      label: "담당자", value: "taxpayerManager", action: setActiveTab,
      isHide: () => !isNumber(previewCustodian?.careCompanyIdx)
    },
    {
      label: "계약정보", value: "billings", action: setActiveTab,
    },
    { label: "그룹정보", value: "group", action: setActiveTab },
    { label: "메모", value: "memo", action: setActiveTab },
    { label: "담당자 상담", value: "counseling", action: setActiveTab, isHide: () => !previewCustodian?.companyToTaxpayer },
  ];

  const checkedSync = (key = "all") => {
    const keys = {
      companyStatus: "txprStatNm",
      ceoName: "rprsTxprNm",
      companyName: "txprNm",
      email: "pfbEml",
      businessType: "taPrxClntClCd",
      openDate: "ofbDt",
      closeDate: "cfbDt",
      rgeNum: "resno",
      address: "roadAdr",
      tel: "telno",
      mobile: "mpno",
      startDate: "afaDt",
      expiredDate: "dsmsDt",
      reason: "txaaDsmsRsnNm",
      industryStCode: "tfbCd",
      industryType: "bcNm",
      industrySect: "itmNm",
      cashAffiliate: "cshptJnnYn",
      cardAffiliate: "crdcJnnYn",
      withholdingTaxDivision: "whtxDutyClNm",
      isVat: "whlPmtBmanYn",
      taxOffice: "abftChrgTxhfOgzNm",
      taxManager: "agent",
    };

    if (previewCustodian) {
      if (key !== "all") {

        if (key.includes("Date")) {
          return {
            [key]: previewCustodian[key] !== previewCustodian[keys[key]]
          };
        } else {
          return {
            [key]: dateToFormat(isArray(previewCustodian[key]) ? previewCustodian[key][0] : previewCustodian[key]) !== previewCustodian[keys[key]]
          };
        }
      } else {
        return {
          companyStatus: previewCustodian.companyStatus !== previewCustodian.txprStatNm,
          ceoName: previewCustodian.ceoName !== previewCustodian.rprsTxprNm,
          companyName: previewCustodian.companyName !== previewCustodian.txprNm,
          email: previewCustodian.email !== previewCustodian.pfbEml,
          businessType: previewCustodian.businessType !== previewCustodian.taPrxClntClCd,
          openDate: dateToFormat(isArray(previewCustodian.openDate) ? previewCustodian.openDate[0] : previewCustodian.openDate) !== dateToFormat(previewCustodian.ofbDt),
          closeDate: dateToFormat(isArray(previewCustodian.closeDate) ? previewCustodian.closeDate[0] : previewCustodian.closeDate) !== dateToFormat(previewCustodian.cfbDt),
          rgeNum: previewCustodian.rgeNum !== previewCustodian.resno,
          address: previewCustodian.address !== previewCustodian.roadAdr,
          tel: previewCustodian.tel !== previewCustodian.telno,
          mobile: previewCustodian.mobile !== previewCustodian.mpno,
          startDate: dateToFormat(isArray(previewCustodian.startDate) ? previewCustodian.startDate[0] : previewCustodian.startDate) !== dateToFormat(previewCustodian.afaDt),
          expiredDate: dateToFormat(isArray(previewCustodian.expiredDate) ? previewCustodian.expiredDate[0] : previewCustodian.expiredDate) !== dateToFormat(previewCustodian.dsmsDt),
          reason: previewCustodian.reason !== previewCustodian.txaaDsmsRsnNm,
          industryStCode: previewCustodian.industryStCode !== previewCustodian.tfbCd,
          industryType: previewCustodian.industryType !== previewCustodian.bcNm,
          industrySect: previewCustodian.industrySect !== previewCustodian.itmNm,
          cashAffiliate: previewCustodian.cashAffiliate !== previewCustodian.cshptJnnYn,
          cardAffiliate: previewCustodian.cardAffiliate !== previewCustodian.crdcJnnYn,
          withholdingTaxDivision: previewCustodian.withholdingTaxDivision !== previewCustodian.whtxDutyClNm,
          isVat: previewCustodian.isVat !== previewCustodian.whlPmtBmanYn,
          taxOffice: previewCustodian.taxOffice !== previewCustodian.abftChrgTxhfOgzNm,
          taxManager: previewCustodian.taxManager !== previewCustodian.agent,
        };
      }
    }
  };

  const _settingFields = async () => {
    if (isEmpty(careCompanies)) {
      setCareCompanies(
        _careCompanies
          .filter(f => f.companyIdx !== company.idx)
          .map(item => ({ value: item.companyIdx, label: item.name, ...item }))
      );
    }

    if (isEmpty(industryCodes)) {
      const resIndustryCodes = await getIndustryCodes();
      const _industryCodes = resIndustryCodes.data.industryCodes.map((industry) => ({
        label: `${industry.type} > ${industry.sect} (${industry.code})`,
        value: industry.stCode,
        industry,
      }));
      setIndustryCodes(_industryCodes);
    }

    const checkedSyncData = checkedSync() || {};


    const managementFields = [
      [
        {
          title: (
            <>
              <span className={`${checkedSyncData.companyName ? "font-bold" : ""}`}>상호명</span>
              {checkedSyncData.companyName && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          key: "companyName",
          type: "input",
          required: true,
          isHide: () => activeTab !== "management",
          placeholder: "상호명 입력",
          options: {
            title: "상호명"
          }
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.ceoName ? "font-bold" : ""}`}>대표자명</span>
              {checkedSyncData.ceoName && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          key: "ceoName",
          type: "input",
          isHide: () => activeTab !== "management",
          placeholder: "대표자명 입력",
          options: {
            title: "대표자명"
          }
        },
      ],
      [
        {
          title: "사업자등록번호",
          key: "bsno",
          type: "input",
          validators: ['comNum'],
          // mode: form?.isWecake === "1" ? "view" : mode,
          required: true,
          isHide: () => activeTab !== "management",
          disabled: true,
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.rgeNum ? "font-bold" : ""}`}>대표자 주민번호</span>
              {checkedSyncData.rgeNum && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          label: '대표자 주민번호',
          placeholder: '대표자 주민번호 입력',
          titlestyle: {
            lineHeight: '15px'
          },
          key: "rgeNum",
          type: "input",
          isHide: () => activeTab !== "management",
          validators: ['jumin'],
          options: {
            title: "대표자 주민번호"
          }
        },
      ],
      [
        {
          title: "수임유형",
          key: "type",
          type: "checkboxes",
          className: "margin-right-16",
          checkedList,
          options: {
            list: MANAGEMENT_TYPE,
          },
          onChange: (checked, value) => {
            let _selectedCheckboxes = [];
            if (checked) {
              _selectedCheckboxes = [...checkedList, value];
            } else {
              _selectedCheckboxes = remove(checkedList, (v) => v !== value);
            }
            setCheckedList(_selectedCheckboxes);
          },
          isHide: () => activeTab !== "management",
        },
      ],

      [
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.companyStatus ? "font-bold" : ""}`}>계속사업자 여부</span>
              {checkedSyncData.companyStatus && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "companyStatus",
          type: "input",
          placeholder: "계속사업자 여부 입력",
          options: {
            title: "계속사업자 여부"
          }
        },
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.businessType ? "font-bold" : ""}`}>유형 구분</span>
              {checkedSyncData.businessType && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "businessType",
          type: "input",
          placeholder: "유형 구분 입력",
          options: {
            title: "유형 구분"
          },
        },
      ],
      [
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.openDate ? "font-bold" : ""}`}>개업일자</span>
              {checkedSyncData.openDate && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "openDate",
          type: "datepicker",
        },
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.closeDate ? "font-bold" : ""}`}>폐업일자</span>
              {checkedSyncData.closeDate && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "closeDate",
          type: "datepicker",
        },
      ],
      [
        {
          title: (
            <>
              <span className={`${checkedSyncData.startDate ? "font-bold" : ""}`}>수임일자</span>
              {checkedSyncData.startDate && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          key: "startDate",
          type: "datepicker",
          isHide: () => activeTab !== "management",
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.expiredDate ? "font-bold" : ""}`}>해임일자</span>
              {checkedSyncData.expiredDate && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          key: "expiredDate",
          type: "datepicker",
          isHide: () => activeTab !== "management",
          onChanged: ({ form, onChange }) => {
            !isEmpty(form?.expiredDate) &&
              isEmpty(previewCustodian?.expiredDate)
              && onChange({ expiredType: "close" });
          }
        },
      ],
      [
        {
          title: "해임사유",
          key: "expiredType",
          type: "radio",
          options: { list: TAXPAYER_EXPIRED_TYPE },
          isHide: () => activeTab !== "management" || isEmpty(form.expiredDate)

        },
      ],
      [
        {
          title: "해임 사유(기타) 입력",
          key: "reason",
          type: "input",
          isHide: () => activeTab !== "management" || form.expiredType !== "etc",
          placeholder: "해임사유 입력"
        },
      ],
      [
        {
          title: "wecake Biz 연동",
          type: "radio",
          key: "isWecake",
          options: {
            list: [{ label: "미연동", value: "0" }, { label: "연동", value: "1" }]
          },
          disabled: isEmpty(_careCompanies.find(f => f.comNum === restoreComNum(form?.bsno))),
          onChange: (e) => {
            let _form = { isWecake: e.target.value, };
            if (_form.isWecake === "1") {

              if (isEmpty(careCompanies)) {
                systemAlert("관리중인 위케이크 회사가 없습니다.");
                setForm({ isWecake: "0" });
                return;
              }

              const careCompany = careCompanies
                .find(f => f.comNum === restoreComNum(form.bsno));

              const txprNm = careCompany.name || form.txprNm;
              const rprsTxprNm = careCompany.ceoName || form.rprsTxprNm;
              const bsno = careCompany.comNum;
              const resno = careCompany.rgeNum || form.resno;

              _form = {
                ..._form,
                txprNm,
                rprsTxprNm,
                bsno,
                resno,
                careCompanyIdx: careCompany.value
              };
            } else {
              _form = {
                ..._form,
                careCompanyIdx: null
              };
            }
            setForm(_form);
          },
          isHide: () => activeTab !== "management",
        },
      ],
      [
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.tel ? "font-bold" : ""}`}>전화번호</span>
              {checkedSyncData.tel && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          label: '전화번호',
          placeholder: "전화번호 입력",
          key: "tel",
          type: "input",
          validators: ['mobileWithAsterisk']
        },
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.mobile ? "font-bold" : ""}`}>휴대폰번호</span>
              {checkedSyncData.mobile && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          label: '휴대폰번호',
          placeholder: "휴대폰번호 입력",
          key: "mobile",
          type: "input",
          validators: ['mobileWithAsterisk']
        },
      ],
      [
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.email ? "font-bold" : ""}`}>이메일</span>
              {checkedSyncData.email && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "이메일 입력",
          key: "email",
          type: "input",
          validators: ['email']
        },
      ],
      [
        {
          isHide: () => activeTab !== "management",
          title: (
            <>
              <span className={`${checkedSyncData.address ? "font-bold" : ""}`}>주소</span>
              {checkedSyncData.address && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "주소 입력",
          key: "",
          type: "address",
          className: 'full',
        }
      ],
    ];

    const etcFields = [
      [
        {
          isHide: () => activeTab !== "etc",
          title: (
            <>
              <span className={`${checkedSyncData.cashAffiliate ? "font-bold" : ""}`}>현금영수증 가맹여부</span>
              {checkedSyncData.cashAffiliate && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "현금영수증 가맹여부 입력",
          key: "cashAffiliate",
          type: "input",
        },
        {
          isHide: () => activeTab !== "etc",
          title: (
            <>
              <span className={`${checkedSyncData.cardAffiliate ? "font-bold" : ""}`}>신용카드 가맹여부</span>
              {checkedSyncData.cardAffiliate && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "신용카드 가맹여부 입력",
          key: "cardAffiliate",
          type: "input",
        },
      ],
      [
        {
          isHide: () => activeTab !== "etc",
          title: (
            <>
              <span className={`${checkedSyncData.withholdingTaxDivision ? "font-bold" : ""}`}>원천징수의무구분</span>
              {checkedSyncData.withholdingTaxDivision && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "원천징수의무구분 입력",
          key: "withholdingTaxDivision",
          type: "input",
        },
        {
          isHide: () => activeTab !== "etc",
          title: (
            <>
              <span className={`${checkedSyncData.isVat ? "font-bold" : ""}`}>(부가세)총괄납부 주사업장여부</span>
              {checkedSyncData.isVat && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "주사업장여부 입력",
          key: "isVat",
          type: "input",
        },
      ],
      [
        {
          isHide: () => activeTab !== "etc",
          title: (
            <>
              <span className={`${checkedSyncData.taxOffice ? "font-bold" : ""}`}>관할세무서</span>
              {checkedSyncData.taxOffice && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "관할세무서 입력",
          key: "taxOffice",
          type: "input",
        },
        {
          isHide: () => activeTab !== "etc",
          title: (
            <>
              <span className={`${checkedSyncData.taxManager ? "font-bold" : ""}`}>담당자성명(전화번호)</span>
              {checkedSyncData.taxManager && <span className="error ml-5 font-size-10">update</span>}
            </>
          ),
          placeholder: "담당자성명(전화번호) 입력",
          key: "taxManager",
          type: "input",
        },
      ],
      {
        isHide: () => activeTab !== "etc",
        title: "업종",
        type: "search-select",
        className: "manager-form-search-select",
        defaultValue: industryCodes.filter(
          (opt) => opt.value === get(form, "industryType")
        ),
        options: {
          list: industryCodes,
          menuPlacement: "top",
        },
        onChange: (data) => {
          setForm({
            ...form,
            industryStCode: data.industry.code,
            industryType: data.industry.type,
            industrySect: data.industry.sect,
          });
        },
      },
      [
        {
          isHide: () => activeTab !== "etc",
          title: "업종코드",
          type: 'text',
          key: 'industryStCode',
          className: 'font-size-13'
        },
        {
          isHide: () => activeTab !== "etc",
          title: "업태",
          type: 'input',
          key: 'industryType',
          className: 'font-size-13'
        },
        {
          isHide: () => activeTab !== "etc",
          title: "업종",
          type: 'input',
          key: 'industrySect',
          className: 'font-size-13'
        },
      ],
      [
        {
          isHide: () => activeTab !== "etc",
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
        },
      ],
      [
        {
          isHide: () => activeTab !== "etc",
          title: "메모",
          key: "memo",
          type: "textarea",
        },
      ],
    ];

    const hometaxFields = [
      /** @description 확인만 가능한 홈택스 데이터 */
      [
        {
          title: (
            <>
              <span className={`${checkedSyncData.companyName ? "font-bold" : ""}`}>상호명</span>
              {checkedSyncData.companyName && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "txprNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.ceoName ? "font-bold" : ""}`}>대표자명</span>
              {checkedSyncData.ceoName && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "rprsTxprNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: (
            <>
              <span className={`${checkedSyncData.companyStatus ? "font-bold" : ""}`}>계속사업자 여부</span>
              {checkedSyncData.companyStatus && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "txprStatNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.businessType ? "font-bold" : ""}`}>유형 구분</span>
              {checkedSyncData.businessType && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "taPrxClntClCd",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: (
            <>
              <span className={`${checkedSyncData.openDate ? "font-bold" : ""}`}>개업일자</span>
              {checkedSyncData.openDate && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "ofbDt",
          isHide: () => activeTab !== "hometax",
          type: "input",
          onValue: (v) => dateToViewFormat(v) || "-",
          disabled: true,
          placeholder: "-"
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.closeDate ? "font-bold" : ""}`}>폐업일자</span>
              {checkedSyncData.closeDate && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "cfbDt",
          isHide: () => activeTab !== "hometax",
          type: "input",
          onValue: (v) => dateToViewFormat(v) || "-",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "사업자등록번호",
          key: "bsno",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: (
            <>
              <span className={`${checkedSyncData.rgeNum ? "font-bold" : ""}`}>주민등록번호</span>
              {checkedSyncData.rgeNum && <span className="error font-size-10 ml-5">update</span>}
            </>
          ),
          key: "resno",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "도로명소재지",
          key: "roadAdr",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "법정동소재지",
          key: "ldAdr",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "이메일",
          key: "pfbEml",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "전화번호",
          key: "telno",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "휴대전화번호",
          key: "mpno",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "국세정보수신동의(휴대폰번호)",
          key: "mpInfrRcvnAgrYn",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "국세정보수신동의(이메일)",
          key: "infrRcvnAgrYn",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "수임일자",
          key: "afaDt",
          isHide: () => activeTab !== "hometax",
          type: "input",
          onValue: (v) => dateToViewFormat(v) || "-",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "해임일자",
          key: "dsmsDt",
          isHide: () => activeTab !== "hometax",
          type: "input",
          onValue: (v) => dateToViewFormat(v) || "-",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "해임사유",
          key: "txaaDsmsRsnNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "세무대리의뢰인 동의여부 코드",
          key: "afaInfrOfrAgrClCd",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "세무대리의뢰인 동의여부",
          key: "afaInfrOfrAgrClNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "정보제공범위 코드",
          key: "infrOfrRngCd",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "정보제공범위",
          key: "infrOfrRngNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "주업종코드",
          key: "tfbCd",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "업태",
          key: "bcNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "종목",
          key: "itmNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "현금영수증 가맹여부",
          key: "cshptJnnYn",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "신용카드 가맹여부",
          key: "crdcJnnYn",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "원천징수의무구분",
          key: "whtxDutyClNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "(부가세)총괄납부 주사업장여부",
          key: "whlPmtBmanYn",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],
      [
        {
          title: "관할세무서",
          key: "abftChrgTxhfOgzNm",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
        {
          title: "담당자성명(전화번호)",
          key: "agent",
          isHide: () => activeTab !== "hometax",
          type: "input",
          disabled: true,
          placeholder: "-"
        },
      ],

    ];
    setFields([...managementFields, ...etcFields, ...hometaxFields]);
  };

  const getParams = (form) => {
    const params = {
      companyName: form.companyName,
      ceoName: form.ceoName,
      bsno: form.bsno,
      rgeNum: form.rgeNum,
      type: checkedList,
      ...(isArray(form.afaDt) && { afaDt: form.afaDt[0] }),
      ...(isArray(form.dsmsDt) && { dsmsDt: form.dsmsDt[0] }),
      fileIdxes: form.fileIdxes,
      memo: form.memo || "",
      careCompanyIdx: +form.isWecake ? form.careCompanyIdx : null,
      companyStatus: form.companyStatus || "",
      businessType: form.businessType || "",
      ...(isArray(form.openDate) && { openDate: form.openDate[0] || "", }),
      ...(isArray(form.closeDate) && { closeDate: form.closeDate[0] || "", }),
      tel: form.tel || "",
      mobile: form.mobile || "",
      email: form.email || "",
      address: [form.address || "", form.addressDetail || ""].join(','),
      industryStCode: form.industryStCode || "",
      industryType: form.industryType || "",
      industrySect: form.industrySect || "",
      ...(isArray(form.expiredDate) && { expiredDate: form.expiredDate[0] || "", }),
      ...(isArray(form.startDate) && { startDate: form.startDate[0] || "", }),
      cashAffiliate: form.cashAffiliate || "",
      cardAffiliate: form.cardAffiliate || "",
      withholdingTaxDivision: form.withholdingTaxDivision || "",
      isVat: form.isVat || "",
      taxOffice: form.taxOffice || "",
      taxManager: form.taxManager || "",
      expiredType: form.expiredType || "",
      isUse: isEmpty(form.expiredDate),
      reason: form.reason,
    };

    return params;
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setActiveTab("management");
    custodianPreview(null);
    resetForm();
  };

  const _submit = (form) => {
    let checkFile = true;
    if (isArray(form.fileIdxes)) {
      each(form.fileIdxes, (item) => {
        const idx = Number(item);
        if (isNaN(idx) || idx <= 0) {
          checkFile = false;
        }
      });
    }

    if (!checkFile) {
      systemAlert('첨부파일을 확인해 주세요.');
      return;
    }

    const companyName = form.companyName;
    const params = getParams(form);
    if (mode === 'create') {
      systemAlert(`"${companyName}" 수임회사를 등록하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              addManagement(params)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }

                  dispatch(getTaxpayerList());
                });
            }
          }
        ]
      });
    } else {
      systemAlert(`"${companyName}" 수임회사를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              editManagement(previewCustodian.idx, params)
                .then(() => {
                  toast.success("수정이 완료되었습니다.");
                  cancel();
                  if (submit) {
                    submit();
                  }

                  dispatch(getTaxpayerList());
                });
            }
          }
        ]
      });

    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields,
    resetForm,
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    !isEmpty(_careCompanies) && _settingFields();
  }, [_careCompanies, activeTab, checkedList, mode, form, activeTab]);

  useEffect(() => {
    if (previewCustodian) {
      setFields([]);
      const form = {
        ...previewCustodian,
        fileIdxes: previewCustodian.uploadFiles,
        isWecake: !isEmpty(previewCustodian?.companyToTaxpayer?.company) ? "1" : "0",
        ...(previewCustodian.address?.includes(',') ? {
          address: previewCustodian.address.split(',')[0],
          addressDetail: previewCustodian.address.split(',').splice(1)?.join(','),
        } : { address: previewCustodian.address })
      };

      setForm(form);
      setOriginForm(previewCustodian);
      setCheckedList(isArray(previewCustodian.type) && !isEmpty(previewCustodian.type) ? [...previewCustodian.type] : ["bookKeeping"]);
    }

  }, [previewCustodian]);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  const hometaxTaxpayerScraping = async (bsno) => {
    const isAccountCheck = await isTaxAccountantAccountCheck();

    if (!isAccountCheck) {
      systemAlert('홈택스 로그인정보가 없습니다.\n홈택스 설정 메뉴로 이동하시겠습니까?', {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: '이동',
            onClick: () => {
              history.push('/tax-portal/settings/hometax');

            },
          },
        ]
      });
      return;
    }

    viewLoading('홈택스 상세정보를 불러오는 중입니다.');
    scrapingTaxpayerDetailFromHometax(bsno)
      .then((res = {}) => {
        toast.success("불러오기가 완료되었습니다.");
        custodianPreview(previewCustodian.idx);
      }).finally(() => {
        viewLoading(false);
      }
      );

  };

  // const syncTaxpayerByHomtax = async () => {
  //   viewLoading("홈택스 데이터 동기화중입니다.");
  //   taxpayerSynchronization(form.idx)
  //     .then(res => {
  //       toast.success("동기화가 완료되었습니다.");
  //       custodianPreview(form.idx);
  //     }).catch(err => console.error(err.response))
  //     .finally(() => viewLoading(false));

  // };

  const syncBtn = () => {
    // const isCompanyNameChange = previewCustodian?.companyName !== previewCustodian?.txprNm;
    // const isCeoNameChange = previewCustodian?.ceoName !== previewCustodian?.rprsTxprNm;
    // const isRgeNumChange = previewCustodian?.rgeNum !== previewCustodian?.resno;
    // const isStartDateChange = dateToFormat(isArray(previewCustodian?.startDate) ? previewCustodian?.startDate[0] : previewCustodian?.startDate) !== dateToFormat(previewCustodian?.afaDt || "");
    // const isExpiredDateChange =
    // dateToFormat(isArray(previewCustodian?.expiredDate) ? previewCustodian?.expiredDate[0] : previewCustodian?.expiredDate) !== dateToFormat(previewCustodian?.dsmsDt || "");

    // const isNew = getSecondsDiff(previewCustodian?.updatedTime, previewCustodian?.createdTime) >= 10;

    const isNoAgree = previewCustodian?.afaInfrOfrAgrClNm?.includes("미동의");

    const result = isNoAgree ? (
      <>
        <Button
          style={{ width: "100%", pointerEvents: "none" }}
          color="red"
          label="세무대리 의뢰인 미동의 상태입니다."
        />
      </>
    ) :
      // (
      //   isCompanyNameChange ||
      //   isCeoNameChange ||
      //   isRgeNumChange ||
      //   isStartDateChange ||
      //   isExpiredDateChange
      // ) && isNew
      //   ? (
      //     <div className="mb-10 body-btn-wrap">
      //       <Button
      //         style={{ width: "100%" }}
      //         action={async () => {
      //           await syncTaxpayerByHomtax();

      //         }}
      //         label="홈택스 정보 동기화"
      //       />
      //     </div>
      //   )
      //   :
      <></>;
    return result;
  };

  return (
    <Modal
      isOpen={!!previewCustodian}
      close={cancel}
      className="tax-portal-custodian"
    >
      <div className="client-write">
        <ModalHeader>수임회사 {previewCustodian && <>"{form?.companyName || form?.txprNm}" </>}</ModalHeader>
        <ModalTab tabList={tabList} active={activeTab} />
        {isComNum(form.bsno) && (
          <div className="header-btn-wrap">
            <Button
              label={"홈택스 상세정보 불러오기"}
              action={() => { hometaxTaxpayerScraping(restoreComNum(form.bsno)); }}
            />
          </div>
        )}
        {(activeTab === "management" || activeTab === "etc" || activeTab === "hometax") && (
          <>
            {syncBtn()}
            <Form
              mode={mode}
              form={form}
              errors={errors}
              isRequiredShow={true}
              setForm={setForm}
              fields={fields}
              onChange={handleOnChange}
              cancelText={'닫기'}
              submitText={mode === 'create' ? '등록' : '수정'}
              submit={handleSubmit}
              cancel={cancel}
            />
          </>
        )}

        {activeTab === "group" && (
          <CustodianGroups cancel={cancel} cancelText={'닫기'} data={form} />
        )}

        {activeTab === "siteInfo" && previewCustodian && (
          <>
            <TaxpayerSiteInfo
              taxpayer={previewCustodian}
              company={company}
              cancel={cancel}
            />
          </>
        )}

        {activeTab === "memo" && previewCustodian && (
          <TaxpayerScheduleModal
            taxpayer={previewCustodian}
            company={company}
            cancel={cancel}
          />
        )}
        {activeTab === "taxpayerManager" && previewCustodian && (
          <TaxpayerPersonInCharge
            taxpayer={previewCustodian}
            company={company}
            cancel={cancel}
          />
        )}

        {activeTab === "billings" && previewCustodian && (
          <TaxpayerBillings
            taxpayer={previewCustodian}
            company={company}
            cancel={cancel}
          />
        )}

        {activeTab === "manager" && previewCustodian && (
          <ManagerForm
            taxpayer={previewCustodian}
            company={company}
            cancel={cancel}
          />
        )}
        {activeTab === "counseling" && previewCustodian && (
          <CounselingModal
            taxpayer={previewCustodian}
            company={company}
            cancel={cancel}
          />
        )}
      </div>
    </Modal>
  );
};

export default Custodian;
